import QRCode from 'qrcode';

/**
 * Renders a QR code to a Data URL (base64 PNG).
 */
export const renderQrCodeDataUrl = async (value: string): Promise<string> => {
  return await QRCode.toDataURL(value, {
    margin: 2,
    width: 200,
    errorCorrectionLevel: 'H',
    color: {
      dark: '#201c51',
      light: '#ffffff',
    },
  });
};
